/* =========================================================
   Página de producto (Claude Code, 2026-09-20)

   Una sola página, producto.html?id=125749, sirve a los 47 productos: los datos
   salen de PRODUCTS (productos.js) y el contenido largo de FICHAS, aquí abajo.
   Se hizo así, y no 47 archivos, porque un cambio de precio o de foto tiene que
   verse en todas sin editar 47 veces lo mismo.

   ⚠️ SOBRE LO QUE SE PUEDE DECIR
   Nada de tratar, curar, prevenir ni diagnosticar. Un suplemento acompaña una
   rutina, no cura. Los textos hablan de para qué lo usa la gente y qué trae el
   frasco, no de lo que "hace". Esto no es solo criterio: en Chile prometer
   efectos terapéuticos de un suplemento es publicidad prohibida, y en Meta es
   causa de rechazo del anuncio.
   Ver la nota "📦 Productos - Tienda de suplementos" para los datos de cada uno.

   CÓMO SE COMPLETA UNA FICHA (se pueden ir agregando de a poco):
     id: {
       para:  'Una línea: para qué lo usa la gente.',
       trae:  ['Lo que dice la etiqueta', 'Otra cosa de la etiqueta'],
       toma:  'Cómo se toma, según la etiqueta.',
       quien: 'A quién le sirve.',
       ojo:   'Advertencia real si la hay.'   // opcional
     }
   Un producto sin ficha igual muestra su página: aparece el frasco, el precio,
   los packs y las garantías, y se omiten los bloques que falten. Así la página
   sirve desde hoy y mejora a medida que se llenan las fichas.
   ========================================================= */

/* ⚠️ CADA DATO DE AQUÍ SALE DE LA ETIQUETA, LEÍDA UNA POR UNA.
   [corregido 2026-09-20] la primera versión traía ingredientes inventados: al
   Joint Health le puse "glucosamina, condroitina y MSM" cuando el frasco dice
   citrato de magnesio, colágeno hidrolizado, cúrcuma y jengibre; y al colágeno
   lo puse "en polvo, se disuelve en agua" cuando son 60 cápsulas.
   NO SE ESCRIBE UN INGREDIENTE SIN HABERLO VISTO en la foto de la etiqueta
   (${AS_A}img-productos-ID.jpg) o en la nota "🖼️ Banners del inicio". Si no se
   puede leer, se deja fuera: una ficha corta y cierta vale más que una completa
   e inventada, y un ingrediente falso en la etiqueta es un problema legal. */
const FICHAS = {
  /* Los 8 del hero van primero: son los que reciben tráfico de los banners. */
  125749: {   // etiqueta FRZVEO leída el 2026-09-20
    para: 'Acompañar tus articulaciones cuando te cuesta moverte con soltura.',
    trae: ['Citrato de magnesio', 'Colágeno hidrolizado', 'Cúrcuma', 'Jengibre', '60 cápsulas'],
    toma: 'Según la etiqueta del frasco, con un vaso de agua.',
    quien: 'Personas que pasan muchas horas de pie, entrenan, o sienten las rodillas y las manos al levantarse.',
  },
  54685: {   // NAD Life Extension · nota de banners, verificado el 2026-09-19
    para: 'Acompañar tu energía del día a día a medida que pasan los años.',
    trae: ['NAD+ y resveratrol en el mismo frasco', '810 mg', '30 cápsulas'],
    toma: 'Según la etiqueta del frasco.',
    quien: 'Personas de 35 años en adelante que notan que ya no rinden igual a media tarde.',
    ojo: 'Ya trae resveratrol: no hace falta sumarle otro frasco de lo mismo.',
  },
  84659: {   // etiqueta TOPLUX leída el 2026-09-20
    para: 'Sumar colágeno a tu rutina de piel, pelo y uñas.',
    trae: ['Colágeno hidrolizado tipo I (péptidos)', '460 mg', '60 cápsulas'],
    toma: 'Según la etiqueta del frasco.',
    quien: 'Quienes buscan una rutina simple y constante para su piel.',
    ojo: 'La etiqueta dice que no es recomendable para menores de 8 años, embarazadas ni nodrizas.',
  },
  126340: {   // nota de banners, verificado
    para: 'Acompañar tu descanso y tu día con magnesio.',
    trae: ['6 tipos de magnesio', '720 mg por porción', 'Para hombre y mujer'],
    toma: 'Según la etiqueta del frasco. Muchos lo prefieren en la noche.',
    quien: 'Hombres y mujeres que quieren sumar magnesio sin tener que elegir entre tipos.',
  },
  96544: {   // Hepa Health · etiqueta leída el 2026-09-19
    para: 'Acompañar tu digestión y tu alimentación con una mezcla de hierbas.',
    trae: ['7 hierbas: bacurina, boldo, llavelo, cola de caballo, diente de león, menta y hepa',
           '90 cápsulas de 400 mg'],
    toma: 'Según la etiqueta del frasco.',
    quien: 'Quienes quieren sumar hierbas a su rutina de todos los días.',
  },
  103967: {   // etiqueta Swiss Trading Group leída el 2026-09-20
    para: 'Acompañar tu rutina de descanso en la noche.',
    trae: ['Vitaminas B6, B12, D3 y E', 'Minerales: magnesio y zinc', 'Triptófano', '30 g'],
    toma: 'Según la etiqueta, un rato antes de acostarte.',
    quien: 'Personas que quieren ordenar su rutina de sueño.',
    ojo: 'La etiqueta dice que no es recomendable para menores de 8 años, embarazadas ni nodrizas. Si tomas medicamentos para dormir, consulta a tu médico.',
  },
  125747: {   // Selerb NAD+ · nota de banners
    para: 'NAD+ pensado para la rutina de energía de los hombres.',
    trae: ['NAD+', 'L-arginina', 'Cúrcuma', 'Resveratrol'],
    toma: 'Según la etiqueta del frasco.',
    quien: 'Hombres de 35 años en adelante.',
    ojo: 'Ya trae cúrcuma y resveratrol: no hace falta sumarle otro frasco de lo mismo.',
  },
  72697: {   // etiqueta Swiss Nature Labs leída el 2026-09-20
    para: 'Acompañar tu alimentación con una fórmula con selenio y L-cisteína.',
    trae: ['Selenio', 'L-cisteína', 'Con ingredientes naturales', '60 cápsulas'],
    toma: 'Según la etiqueta del frasco.',
    quien: 'Quienes quieren sumar esta fórmula a su rutina de todos los días.',
    ojo: 'La etiqueta dice que no es recomendable para menores de 15 años, ni en embarazo ni lactancia.',
  },

  /* ---- Energía y rendimiento ---------------------------------------- */
  63663: {   // VIDANOVA SUPLES, etiqueta leída el 2026-09-20
    para: 'Acompañar tu rendimiento en el entrenamiento.',
    trae: ['Óxido nítrico', '1.000 mg por cápsula', '60 cápsulas'],
    toma: 'Según la etiqueta del frasco. Muchos lo toman antes de entrenar.',
    quien: 'Quienes entrenan con pesas y buscan apoyo para su rutina.',
  },
  48056: {   // VIDANOVA SUPLES, etiqueta leída el 2026-09-20
    para: 'Sumar creatina a tu rutina de entrenamiento.',
    trae: ['Creatina monohidratada micronizada (200 mesh)', '5 g por servicio',
           '60 servicios', '300 g', 'Sin sabor'],
    toma: 'Una medida de 5 g al día, disuelta en agua o en tu bebida habitual.',
    quien: 'Hombres y mujeres que entrenan fuerza.',
  },
  83439: {   // Buporai, etiqueta leída el 2026-09-20
    para: 'Shilajit en gomitas, para quienes prefieren no tomar cápsulas.',
    trae: ['Shilajit', '1.000 mg por porción', '160 gomitas', 'Sin transgénicos'],
    toma: 'Según la etiqueta del frasco.',
    quien: 'Quienes quieren sumar shilajit sin tragar cápsulas.',
  },
  91096: {   // Old School, etiqueta leída el 2026-09-20
    para: 'Acompañar tu rutina de entrenamiento y energía.',
    trae: ['Turkesterona', 'Cloruro de magnesio', 'L-arginina', 'Cusiana',
           'Bencina pakay', '60 cápsulas'],
    toma: 'Según la etiqueta del frasco.',
    quien: 'Hombres que entrenan y quieren sumar aminoácidos a su rutina.',
    ojo: 'La etiqueta dice que no es recomendable para menores de 15 años, ni en embarazo ni lactancia.',
  },

  /* ---- Mujer --------------------------------------------------------- */
  49208: {   // etiqueta leída el 2026-09-20
    para: 'Gomitas con aguaje y fenogreco, para sumar a tu rutina diaria.',
    trae: ['Aguaje y fenogreco', 'Con probióticos y prebióticos',
           '160 gomitas', 'Sabor artificial a frutas'],
    toma: 'Según la etiqueta del frasco.',
    quien: 'Mujeres que prefieren gomitas antes que cápsulas.',
  },
  64268: {   // Old School, etiqueta leída el 2026-09-20
    para: 'Creatina pensada para la rutina de entrenamiento de las mujeres.',
    trae: ['Creatina monohidratada', '30 servicios', '240 g', 'Sin sabor', 'Sin azúcar añadida'],
    toma: 'Una medida al día, disuelta en agua o en tu bebida habitual.',
    quien: 'Mujeres que entrenan fuerza.',
  },
  23482: {   // Eco Aquapacos, etiqueta leída el 2026-09-20
    para: 'Acompañar tu rutina en esta etapa, con una mezcla de hierbas.',
    trae: ['Salvia', 'Alfalfa', 'Manzanilla', 'Aguyia', 'Vitamina E',
           '90 cápsulas de 400 mg', 'Micropulverizado'],
    toma: 'Según la etiqueta del frasco.',
    quien: 'Mujeres que están pasando por la menopausia.',
    ojo: 'La etiqueta dice: no es un medicamento y no sustituye una alimentación balanceada.',
  },
  64269: {   // URO by Opositiv, etiqueta leída el 2026-09-20
    para: 'Sumar probióticos a tu rutina de cuidado íntimo.',
    trae: ['Probióticos 5B UFC', 'Inulina', 'Frambuesa', '60 cápsulas vegetales', 'Vegano'],
    toma: 'Según la etiqueta del frasco.',
    quien: 'Mujeres que quieren sumar probióticos a su rutina.',
    ojo: 'La etiqueta dice que no es recomendable para menores de 8 años, embarazadas ni nodrizas.',
  },

  /* ---- Sueño, estrés y ánimo ----------------------------------------- */
  54979: {   // VIDANOVA SUPLES, etiqueta leída el 2026-09-20
    para: 'Juntar ashwagandha y magnesio en un solo frasco.',
    trae: ['Ashwagandha', 'Bisglicinato de magnesio', 'Citrato de magnesio',
           '1.000 mg', '60 cápsulas'],
    toma: 'Según la etiqueta del frasco.',
    quien: 'Quienes ya toman los dos por separado y prefieren un solo frasco.',
  },
  96342: {   // Swiss Trading Group, etiqueta leída el 2026-09-20
    para: 'Magnesio con vitaminas, para acompañar tu día.',
    trae: ['Bisglicinato de magnesio', 'Vitamina B6', 'Vitamina D3',
           '60 cápsulas', '31 g'],
    toma: 'Según la etiqueta del frasco.',
    quien: 'Quienes buscan magnesio en su forma bisglicinato.',
  },
  91095: {   // Restzz, etiqueta leída el 2026-09-20
    para: 'Gotas para acompañar tu rutina de descanso en la noche.',
    trae: ['Valeriana', 'Melatonina', 'Tila', '50 ml'],
    toma: 'Las gotas que indique la etiqueta, un rato antes de acostarte.',
    quien: 'Quienes prefieren gotas antes que cápsulas.',
    ojo: 'Si tomas medicamentos para dormir, consulta a tu médico antes.',
  },
  61032: {   // Mountain Valley, etiqueta leída el 2026-09-20
    para: 'Ashwagandha sola, para sumarla a tu rutina.',
    trae: ['Ashwagandha 1.000 mg', 'Vitamina B12', '60 cápsulas'],
    toma: 'Según la etiqueta del frasco.',
    quien: 'Quienes quieren ashwagandha sin mezclas.',
  },

  /* ---- Metabolismo ---------------------------------------------------- */
  95120: {   // Lemme Burn, etiqueta leída el 2026-09-20
    para: 'Acompañar tu alimentación con té verde y complejo B.',
    trae: ['Té verde', 'Pepa de uva', 'Complejo B', 'Chitosán', '60 cápsulas'],
    toma: 'Según la etiqueta del frasco.',
    quien: 'Quienes quieren sumar esta mezcla a su rutina.',
    ojo: 'La etiqueta dice que no es recomendable para menores de 18 años, embarazadas ni nodrizas, y que no reemplaza una alimentación balanceada.',
  },
  91660: {   // VIDANOVA SUPLES, etiqueta leída el 2026-09-20
    para: 'Vinagre de manzana en gomitas, sin el sabor del vinagre.',
    trae: ['Vinagre de manzana', '1.000 mg', '30 gomitas', 'Sabor manzana',
           'Vegano, sin gluten y sin azúcar'],
    toma: 'Según la etiqueta del frasco.',
    quien: 'Quienes quieren tomar vinagre de manzana sin tomárselo en líquido.',
  },
  125745: {   // Puritan's Pride, etiqueta leída el 2026-09-20
    para: 'Berberina sola, para sumarla a tu rutina.',
    trae: ['Berberina 500 mg', 'Alcaloide de origen vegetal', '60 cápsulas vegetales'],
    toma: 'Según la etiqueta del frasco.',
    quien: 'Quienes buscan berberina sin mezclas.',
  },
  72945: {   // Swiss Trading Group, etiqueta leída el 2026-09-20
    para: 'Acompañar tu alimentación del día a día.',
    trae: ['60 g', 'Desarrollado en Estados Unidos'],
    toma: 'Según la etiqueta del frasco.',
    quien: 'Quienes quieren sumarlo a su rutina de alimentación.',
  },
  158579: {   // Aurelys, etiqueta leída el 2026-09-20
    para: 'Extracto líquido de hierbas, en gotas.',
    trae: ['Diente de león', 'Ortiga', 'Té verde', 'Trébol rojo', 'Castaño de Indias',
           'Rusco', 'Jengibre', 'Cúrcuma', '30 ml'],
    toma: 'Las gotas que indique la etiqueta.',
    quien: 'Quienes prefieren gotas antes que cápsulas.',
  },

  /* ---- Longevidad ----------------------------------------------------- */
  46242: {   // GreenWorld, etiqueta leída el 2026-09-20
    para: 'Resveratrol de extracto de vino tinto, para sumarlo a tu rutina.',
    trae: ['Resveratrol 590 mg', 'Extracto de vino tinto', 'Pepa de uva', 'Arándano',
           '60 cápsulas'],
    toma: 'Según la etiqueta del frasco.',
    quien: 'Quienes quieren resveratrol sin mezclas.',
    ojo: 'La etiqueta dice que no es recomendado para menores de 8 años, embarazadas ni nodrizas.',
  },
  58061: {   // VIDANOVA SUPLES, pack de 3 frascos, etiquetas leídas el 2026-09-20
    para: 'Tres frascos en un solo pedido: NAD+, ashwagandha y Candida Cleanse.',
    trae: ['NAD+ con resveratrol, nicotinamida ribósido, ácido alfa lipoico y complejo B — 60 cápsulas',
           'Ashwagandha con bisglicinato y citrato de magnesio — 60 cápsulas',
           'Candida Cleanse con caprílico, extracto de ajo y extractos herbales — 60 cápsulas'],
    toma: 'Cada frasco según su propia etiqueta.',
    quien: 'Quienes quieren los tres y prefieren pedirlos juntos en un solo envío.',
  },
  87268: {   // VIDANOVA SUPLES, pack de 3 frascos iguales, etiqueta leída el 2026-09-20
    para: 'Tres frascos del mismo NAD+ con resveratrol, para varios meses.',
    trae: ['3 frascos de NAD+ con resveratrol', '500 mg', '60 cápsulas cada uno'],
    toma: 'Según la etiqueta del frasco.',
    quien: 'Quienes ya lo toman y quieren dejarlo resuelto por varios meses.',
  },

  /* ---- Hígado y digestión --------------------------------------------- */
  57201: {   // etiqueta leída el 2026-09-20
    para: 'Acompañar tu digestión durante 15 días.',
    trae: ['30 cápsulas', 'Para 15 días'],
    toma: 'Según la etiqueta del frasco.',
    quien: 'Quienes quieren hacer una rutina corta y con principio y fin.',
  },
  37301: {   // Pure Peak, etiqueta leída el 2026-09-20
    para: 'Acompañar tu digestión con caprilato y extractos de hierbas.',
    trae: ['Caprilato', 'Extractos herbales', '60 cápsulas', 'Producto natural'],
    toma: 'Según la etiqueta del frasco.',
    quien: 'Quienes quieren sumar esta fórmula a su rutina.',
  },
  35868: {   // Mita Michuen, etiqueta leída el 2026-09-20
    para: 'Mezcla de hierbas para acompañar tu digestión.',
    trae: ['Balahsen', 'Aloe vera', 'Propóleo', 'Manzanilla', 'Anís', '60 cápsulas'],
    toma: 'Según la etiqueta del frasco.',
    quien: 'Quienes prefieren una fórmula de hierbas conocidas.',
  },
  84072: {   // Carlyle, etiqueta leída el 2026-09-20
    para: 'Aceite de orégano orgánico, en gotas.',
    trae: ['Aceite de orégano orgánico (USDA Organic)', '59 ml (2 fl. oz.)',
           'Sin transgénicos', 'Sin gluten'],
    toma: 'Las gotas que indique la etiqueta.',
    quien: 'Quienes buscan orégano en aceite y prefieren gotas.',
  },

  /* ---- Articulaciones y huesos ---------------------------------------- */
  67632: {   // Micro Ingredients, etiqueta leída el 2026-09-20
    para: 'Cúrcuma concentrada, con lo que ayuda a absorberla.',
    trae: ['Cúrcuma 1.000 mg por porción', '95% curcuminoides', 'Propóleo de abeja',
           'Jengibre', 'Extracto de pimienta negra', 'Aceite MCT',
           'Vitamina C liposoluble', '60 cápsulas vegetarianas'],
    toma: 'Según la etiqueta del frasco.',
    quien: 'Quienes ya toman cúrcuma y quieren una versión concentrada.',
  },
  97448: {   // Swiss Trading Group, etiqueta leída el 2026-09-20
    para: 'Acompañar tus huesos con calcio y vitaminas.',
    trae: ['Calcio', 'Manganeso', 'Vitamina D3', 'Vitamina K2',
           '90 cápsulas', '65 g'],
    toma: 'Según la etiqueta del frasco.',
    quien: 'Personas adultas que quieren sumar calcio a su alimentación.',
    ojo: 'La etiqueta dice que no es recomendable para menores de 8 años, embarazadas ni nodrizas.',
  },
  96539: {   // Eco Nutrition, etiqueta leída el 2026-09-20
    para: 'Calcio, magnesio y colágeno en un solo frasco.',
    trae: ['Calcio', 'Magnesio', 'Colágeno hidrolizado', 'Vitamina D',
           '90 cápsulas de 500 mg', '45 g'],
    toma: 'Según la etiqueta del frasco.',
    quien: 'Personas adultas que quieren cuidar huesos, músculos y articulaciones.',
  },

  /* ---- Belleza -------------------------------------------------------- */
  96541: {   // Eco Nutrition, etiqueta leída el 2026-09-20
    para: 'Colágeno con biotina, para tu rutina de piel, pelo y uñas.',
    trae: ['Colágeno', 'Biotina', '90 cápsulas de 430 mg', '38,7 g'],
    toma: 'Según la etiqueta del frasco.',
    quien: 'Quienes quieren juntar colágeno y biotina sin comprar dos frascos.',
  },
  63664: {   // VIDANOVA SUPLES, etiqueta leída el 2026-09-20
    para: 'Biotina y colágeno con vitaminas, en un solo frasco.',
    trae: ['Biotina', 'Colágeno', 'Complejo B', 'Vitaminas A, C, D y E',
           '60 cápsulas de 1.000 mg'],
    toma: 'Según la etiqueta del frasco.',
    quien: 'Quienes buscan una fórmula con varias vitaminas además del colágeno.',
  },
  72944: {   // Swiss Trading Group, etiqueta leída el 2026-09-20
    para: 'Colágeno en cápsulas, para tomar todos los días.',
    trae: ['Colágeno hidrolizado', '90 cápsulas', 'Viene en su caja'],
    toma: 'Según la etiqueta: la porción recomendada al día.',
    quien: 'Quienes prefieren cápsulas antes que polvo.',
    ojo: 'La etiqueta dice que, si estás con algún tratamiento médico, consultes antes.',
  },

  /* ---- Hombre 40+ y bienestar ----------------------------------------- */
  72695: {   // Swiss Nature Labs, etiqueta leída el 2026-09-20
    para: 'Fórmula con aminoácidos y zinc, para la rutina del hombre.',
    trae: ['L-arginina', 'Beta alanina', 'L-carnitina', 'Vitaminas D y E', 'Zinc',
           'Pepa de calabaza', 'Ortiga', '30 cápsulas', '21 g'],
    toma: 'Una cápsula al día, según la etiqueta.',
    quien: 'Hombres que quieren sumar esta fórmula a su rutina.',
    ojo: 'La etiqueta dice que no es recomendable para menores de 15 años, ni en embarazo ni lactancia. Si estás con tratamiento médico, consulta antes.',
  },
  65555: {   // Hallusa Natural, etiqueta leída el 2026-09-20
    para: 'Pepa de calabaza y zinc, para la rutina del hombre.',
    trae: ['Pepa de calabaza', 'Óxido de zinc', '60 cápsulas', '36 g'],
    toma: 'Según la etiqueta del frasco.',
    quien: 'Hombres que buscan una fórmula simple y con pocos ingredientes.',
    ojo: 'La etiqueta dice que no es recomendable para menores de 8 años, embarazadas ni nodrizas.',
  },
  59438: {   // VIDANOVA SUPLES, etiqueta leída el 2026-09-20
    para: 'Melena de león con magnesio y complejo B.',
    trae: ['Melena de león', 'Magnesio L-treonato', 'Complejo B', 'Fosfatidilserina',
           '60 cápsulas de 1.000 mg'],
    toma: 'Según la etiqueta del frasco.',
    quien: 'Quienes quieren sumar melena de león a su rutina.',
  },
  72696: {   // Swiss Nature Labs, etiqueta leída el 2026-09-20
    para: 'Fórmula con vitaminas y té verde, de ingredientes naturales.',
    trae: ['Vitaminas C, B3, B6, B12 y folato', 'Extracto de té verde', '60 cápsulas'],
    toma: 'Según la etiqueta del frasco.',
    quien: 'Quienes quieren sumar esta fórmula a su rutina.',
    ojo: 'La etiqueta dice que no es recomendable para menores de 15 años, ni en embarazo ni lactancia.',
  },
  89150: {   // Swiss Trading Group, etiqueta leída el 2026-09-20
    para: 'Fórmula de origen natural con vitamina C.',
    trae: ['Vitamina C', 'Origen natural', 'Desarrollado en Europa', '20 g'],
    toma: 'Según la etiqueta del frasco.',
    quien: 'Quienes pasan muchas horas de pie o sentados.',
    ojo: 'La etiqueta dice que no es recomendable para menores de 15 años, ni en embarazo ni lactancia.',
  },

  50838: {   // Physician's Choice, etiqueta leída el 2026-09-20
    para: 'Sumar fibra a tu día, en gomitas.',
    trae: ['5 g de fibra por porción', '60 gomitas', 'Sabor frambuesa y limón',
           'Saborizado con sabores naturales'],
    toma: 'Según la etiqueta del frasco.',
    quien: 'Quienes saben que les falta fibra y no quieren tomarla en polvo.',
  },
};

/* Preguntas iguales para todos: son de la tienda, no del producto. */
const FAQ_PRODUCTO = [
  ['¿Cómo pago?', 'Pagas en tu casa, cuando el pedido llega. No pagas nada por adelantado.'],
  ['¿Cuánto demora?', 'Preparamos tu pedido en 1 a 2 días hábiles. Desde el despacho llega en 1 a 3 días hábiles en la Región Metropolitana y 2 a 7 en regiones.'],
  ['¿Y si no me convence?', 'Tienes 30 días desde que lo recibes para pedir una devolución, según nuestra política de reembolso.'],
  ['¿Puedo tomarlo si tomo medicamentos?', 'Consulta antes a tu médico. Lo recomendamos siempre antes de empezar cualquier suplemento.'],
];

/* ---------- cuándo llega --------------------------------------------------
   Urgencia que NO se inventa: sale de la política de envíos publicada.
   Preparación 1 a 2 días hábiles + tránsito 1 a 3 en la Región Metropolitana
   (2 a 7 en regiones) = 2 a 5 días hábiles en Santiago y hasta 9 en regiones.
   No descuenta feriados: por eso se dice "entre" y "hasta", no una fecha exacta.
   Si cambia la política de envíos, cambian estos números. */
const LLEGA = { rmMin: 2, rmMax: 5, regMax: 9 };
function sumaHabiles(n) {
  const d = new Date();
  let k = 0;
  while (k < n) {
    d.setDate(d.getDate() + 1);
    if (d.getDay() !== 0 && d.getDay() !== 6) k++;
  }
  return d;
}
const diaCorto = (d) => d.toLocaleDateString('es-CL', { weekday: 'short', day: 'numeric', month: 'short' });
function textoLlegada() {
  return `Pídelo hoy y en Santiago te llega entre el <b>${diaCorto(sumaHabiles(LLEGA.rmMin))}</b> `
    + `y el <b>${diaCorto(sumaHabiles(LLEGA.rmMax))}</b>. `
    + `<span>A regiones, hasta el ${diaCorto(sumaHabiles(LLEGA.regMax))}.</span>`;
}

/* ---------- barra de compra que acompaña -----------------------------------
   Aparece cuando el botón principal se pierde de vista al bajar por la ficha,
   y se esconde al volver a verlo. Muestra el precio del pack que el cliente
   eligió, no el de 1 unidad: si no, dice un precio y cobra otro. */
function barraCompra(el) {
  const bar = el.querySelector('.pd-buybar');
  const boton = el.querySelector('.pd-comprar');
  const precio = el.querySelector('.pd-info [data-precio]');
  if (!bar || !boton || !precio) return;
  const barPrecio = bar.querySelector('[data-bar-precio]');
  const barUds = bar.querySelector('[data-bar-uds]');

  /* La barra copia el precio de arriba en vez de calcularlo: así da igual desde
     dónde cambie (elegir 2 unidades, ganar el descuento del juego), nunca se
     queda con un número viejo.

     [2026-10-03] Y dice CUÁNTAS UNIDADES. Sin eso, "$44.900" en la barra se lee
     como el precio de UN frasco justo cuando el cliente lleva dos por ese
     precio: la mejor parte de la oferta desaparecía al bajar. */
  const copia = () => {
    barPrecio.textContent = precio.textContent;
    if (!barUds) return;
    const ops = [...el.querySelectorAll('.p-packs [data-pack]')];
    const i = ops.findIndex((o) => o.classList.contains('on'));
    /* "u." y no "unidades": la barra es una sola línea y con la palabra entera
       se partía en dos en un teléfono angosto. Es la misma abreviatura que ya
       usan las opciones de cantidad, así que no hay que aprender nada nuevo. */
    barUds.textContent = i > 0 ? `${i + 1} u. · ` : '';
  };
  new MutationObserver(copia).observe(precio, { childList: true, characterData: true, subtree: true });
  copia();

  const pon = (v) => {
    bar.classList.toggle('show', v);
    bar.setAttribute('aria-hidden', !v);
    document.body.classList.toggle('has-buybar', v);
  };

  /* [2026-10-03] Jacsson: *"me falta que el botón de compra esté siempre visible
     y lo vaya siguiendo al cliente"*. Tenía razón, y el agujero era grande.

     Antes la barra aparecía SOLO si el botón ya había pasado hacia arriba
     (`boundingClientRect.top < 0`). Pero en el teléfono el botón de verdad está a
     1.210 px del inicio: medido, hay que bajar 366 px para llegar a él. Es decir
     que **al abrir la ficha no había ningún botón de comprar a la vista**, ni el
     real ni la barra — justo en el momento de más interés, recién llegado del
     banner.

     Ahora la regla es la única que tiene sentido: la barra está siempre que el
     botón de verdad NO se vea, esté arriba o abajo. Así nunca hay dos botones
     pidiendo lo mismo, y nunca hay ninguno. */
  /* [anterior: Claude Code, 2026-10-03] la barra se escondía mientras el botón
     de verdad estuviera a la vista:
       new IntersectionObserver(([e]) => pon(!e.isIntersecting)).observe(boton);
     [2026-10-03 17:10] Jacsson: "con el botón de comprar ahora SIEMPRE visible".
     Con el carrusel bajo la foto, el botón de verdad quedó más abajo todavía,
     así que la barra se queda fija desde que abre la ficha. */
  /* [2026-10-03, auditoría] En el COMPUTADOR la barra tapaba el botón de verdad
     al abrir (botón a 788 px en una pantalla de 900). Ahí la pantalla es grande y
     el botón se ve: la barra sale solo cuando el botón ya no está a la vista.
     En el celular sigue SIEMPRE visible, como pidió Jacsson. */
  const grande = matchMedia('(min-width: 880px)');
  let botonVisible = false;
  const decide = () => pon(grande.matches ? !botonVisible : true);
  new IntersectionObserver(([e]) => { botonVisible = e.isIntersecting; decide(); },
    { rootMargin: '0px 0px -90px 0px' }).observe(boton);
  grande.addEventListener('change', decide);
  decide();
}

/* ═══ LLEGAR CON LAS UNIDADES YA ELEGIDAS ═══════════════════════════════════
   [2026-10-03] El banner del Cyber promete 2x1 y ahora enlaza
   `producto.html?id=65555&u=2`. Si la ficha abriera en 1 unidad, el cliente
   vería $44.900 por UN frasco y tendría que descubrir solo dónde se activa la
   oferta que lo trajo. Eso es un paso de más y, peor, parece que la promesa no
   era cierta.

   No se repinta el precio a mano: se dispara un clic en la opción, que es lo
   que ya sabe actualizar el precio, la línea del descuento y la barra del pie.
   Si mañana cambia cómo se calcula un pack, esto sigue funcionando.

   Se hace en el cuadro siguiente (`requestAnimationFrame`) porque el oyente que
   atiende el clic vive en app.js y puede no estar puesto todavía. */
function unidadesDelEnlace(el) {
  /* [2026-10-03, auditoría] Sin ?u= la ficha abre en 2 UNIDADES: con el 2x1, una
     cuesta lo mismo que dos y abrir en 1 era dejarle al cliente la peor opción
     marcada. Con ?u=1 se respeta el 1.
     [anterior: Claude Code, 2026-10-03] sin ?u= se quedaba en 1:
       if (!(u >= 2)) return;  // 1 ya es lo que viene por defecto */
  let u = 2;
  try {
    const q = new URLSearchParams(location.search).get('u');
    if (q !== null) u = +q || 1;
  } catch (e) { /* sin URL */ }
  if (!(u >= 2)) return;                       // 1 es lo que trae el HTML
  const ops = [...el.querySelectorAll('.p-packs [data-pack]')];
  const elegida = ops[u - 1];
  if (elegida) requestAnimationFrame(() => elegida.click());
}

/* ═══ OPINIONES CON ESTRELLAS ═══════════════════════════════════════════════
   [2026-10-03] El bloque que faltaba. La ficha no tenía NI UNA estrella: el
   cliente llega ya convencido del producto y le queda una sola duda —"¿y si no
   me sirve?"— que el precio no responde. La responde otra persona que ya
   compró. Por eso va aquí y no en la portada: aquí es donde se decide.

   ⚠️⚠️ SON OPINIONES DE EJEMPLO, ESCRITAS POR CLAUDE. No hay clientes todavía.
   Van marcadas con el sello "Ejemplo" en cada tarjeta y con un aviso al pie del
   bloque, igual que las personas de la portada (ver `demoPersonas` en app.js).
   ANTES DE ANUNCIAR EN META hay que cambiarlas por reseñas reales: mostrar
   opiniones inventadas como si fueran de clientes es un riesgo de verdad para
   la cuenta publicitaria, además de una mentira.
   Para cambiarlas: se edita OPINIONES_DEMO de abajo. Nada más.

   DE QUÉ HABLAN, y por qué: del PROCESO (llegó rápido, pagué al recibir, una
   cápsula y listo, la etiqueta se puede leer) y no de curaciones. Un suplemento
   no cura nada, y una reseña que promete resultados médicos es justo lo que
   Meta castiga. */

/* El texto cambia según la categoría, para que una opinión de un producto de
   sueño no hable de ir al gimnasio. `general` es el respaldo si algún producto
   queda sin categoría conocida. */
const OPINIONES_DEMO = {
  energia: [
    { t: 'Me acomodó la rutina', q: 'Entreno después del trabajo y necesitaba algo que no me diera más vueltas. Una toma con el desayuno y no lo pienso más en todo el día.', n: 'Rodrigo M.', m: 'Puente Alto', e: 5 },
    { t: 'Llegó en dos días', q: 'Pedí el martes y el jueves ya estaba en la casa. Pagué al recibir, que era lo que me daba más confianza para probar.', n: 'Felipe S.', m: 'Concepción', e: 5 },
    { t: 'Un solo paquete', q: 'Antes compraba cada cosa en una tienda distinta y me llegaban por separado. Acá fue un pedido y un envío.', n: 'Marco V.', m: 'Rancagua', e: 5 },
    { t: 'Bien, con una pega', q: 'El frasco cumple y el envío fue rápido. Lo único, me habría gustado que el pote fuera un poco más chico para llevarlo al trabajo.', n: 'Andrés T.', m: 'Quilpué', e: 4 },
  ],
  mujer: [
    { t: 'Por fin algo que mantengo', q: 'Soy mamá y contadora, la mañana se me hace corta. Esto es rápido de tomar y ya llevo el segundo frasco seguido, cosa que nunca me pasaba.', n: 'Carolina P.', m: 'Viña del Mar', e: 5 },
    { t: 'Pude leer la etiqueta', q: 'Me gustó ver la etiqueta completa en la página antes de comprar. Con lo que una toma, quiero saber qué trae.', n: 'Daniela R.', m: 'Ñuñoa', e: 5 },
    { t: 'Pagué cuando llegó', q: 'Nunca había comprado suplementos por internet. Que se pagara al recibir fue lo que me decidió.', n: 'Paulina G.', m: 'La Florida', e: 5 },
    { t: 'Buena, pero tardó', q: 'El producto bien y la atención también. A regiones se demoró un poco más de lo que decía, pero avisaron.', n: 'Javiera M.', m: 'Puerto Montt', e: 4 },
  ],
  descanso: [
    { t: 'Simple de seguir', q: 'Lo dejé en el velador y ya es parte de acostarme. No tengo que acordarme de nada ni medir nada.', n: 'Gonzalo I.', m: 'Maipú', e: 5 },
    { t: 'Llegó bien sellado', q: 'Venía con el sello de seguridad intacto y la fecha clara en el frasco. Eso lo reviso siempre.', n: 'Ximena B.', m: 'Providencia', e: 5 },
    { t: 'Me contestaron el mismo día', q: 'Escribí preguntando antes de pedir y me respondieron el mismo día. Compré por eso.', n: 'Hernán C.', m: 'Temuco', e: 5 },
    { t: 'Cumple', q: 'Hace lo que dice y llegó cuando dijeron. Le pongo cuatro porque el frasco es más chico de lo que imaginé.', n: 'Rodrigo A.', m: 'San Bernardo', e: 4 },
  ],
  metabolismo: [
    { t: 'Lo tomo con el desayuno', q: 'Buscaba algo que no me cambiara la rutina. Lo dejé al lado del café y listo.', n: 'Claudia N.', m: 'Antofagasta', e: 5 },
    { t: 'Aproveché el 2x1', q: 'Llevé dos para no quedarme a medias el mes siguiente. Llegaron juntos en el mismo paquete.', n: 'Sebastián R.', m: 'La Serena', e: 5 },
    { t: 'Sin pagar por adelantado', q: 'Me daba lata dar la tarjeta en una tienda que no conocía. Pagar en la puerta me sacó esa duda.', n: 'Pamela O.', m: 'Talca', e: 5 },
    { t: 'Bien el envío', q: 'Rápido y bien embalado. Le bajo una estrella porque la caja venía un poco golpeada, aunque el frasco estaba perfecto.', n: 'Luis F.', m: 'Iquique', e: 4 },
  ],
  longevidad: [
    { t: 'Una rutina sin pensarlo', q: 'Me jubilé hace poco y quería algo simple de mantener, sin estar viendo qué comprar cada mes.', n: 'Jorge A.', m: 'La Serena', e: 5 },
    { t: 'La etiqueta, tal cual', q: 'Lo que dice la página es lo que trae el frasco. Lo comparé cuando llegó.', n: 'Eduardo S.', m: 'Valdivia', e: 5 },
    { t: 'Buena atención', q: 'Tuve una duda con la dosis y me explicaron derecho, sin venderme otra cosa.', n: 'Nelson P.', m: 'Chillán', e: 5 },
    { t: 'Todo bien', q: 'Llegó cuando dijeron y pagué ahí mismo. Cuatro estrellas porque me gustaría que vinieran más cápsulas por frasco.', n: 'Víctor H.', m: 'Osorno', e: 4 },
  ],
  digestion: [
    { t: 'Fácil de incorporar', q: 'Una al día con la comida y no me complica. Es lo que buscaba.', n: 'Marcela S.', m: 'Copiapó', e: 5 },
    { t: 'Llegó a la oficina', q: 'Lo mandé a la dirección del trabajo porque paro poco en la casa. Sin problema.', n: 'Héctor P.', m: 'Talca', e: 5 },
    { t: 'Me gustó la transparencia', q: 'Dicen qué es y qué no es. No prometen que te va a cambiar la vida, y eso me dio más confianza.', n: 'Ana L.', m: 'Santiago Centro', e: 5 },
    { t: 'Bien', q: 'Cumple lo que ofrece. Le pongo cuatro porque esperaba que el sabor fuera más neutro.', n: 'Diego M.', m: 'Coquimbo', e: 4 },
  ],
  articulaciones: [
    { t: 'Una cápsula y listo', q: 'Hago turnos y paso fuera de la casa. Que sea una sola al día me sirve.', n: 'Óscar L.', m: 'Antofagasta', e: 5 },
    { t: 'Volví de a poco', q: 'Volví a moverme después de años parado. Escribí antes de pedir y me contestaron las dudas el mismo día.', n: 'Cristián A.', m: 'Maipú', e: 5 },
    { t: 'Pedido simple', q: 'Dos clics y listo, sin crear cuenta ni dejar la tarjeta. Pagué cuando llegó.', n: 'Manuel R.', m: 'Curicó', e: 5 },
    { t: 'Conforme', q: 'Llegó rápido y bien. Le bajo una estrella porque me habría gustado más información del origen en la caja.', n: 'Patricio G.', m: 'Los Ángeles', e: 4 },
  ],
  belleza: [
    { t: 'Lo sumé sin esfuerzo', q: 'Lo dejé junto a las cosas del baño y ya es parte de la mañana. Eso es lo que me hacía falta.', n: 'Valentina C.', m: 'Santiago', e: 5 },
    { t: 'Llegó impecable', q: 'Bien embalado y con el sello puesto. Se nota que lo mandan con cuidado.', n: 'Fernanda D.', m: 'Las Condes', e: 5 },
    { t: 'Compré sin miedo', q: 'Era primera vez que compraba acá. Pagar al recibir fue lo que me hizo atreverme.', n: 'Camila Z.', m: 'Rancagua', e: 5 },
    { t: 'Me sirvió', q: 'Buen producto y buena atención. Cuatro porque el envase es más chico de lo que se ve en la foto.', n: 'Antonia V.', m: 'Viña del Mar', e: 4 },
  ],
  bienestar: [
    { t: 'Parte del día', q: 'Lo tomo con el desayuno y ya no lo pienso. Buscaba justo eso: algo que no me costara mantener.', n: 'Ignacio R.', m: 'Santiago', e: 5 },
    { t: 'Rápido y sin vueltas', q: 'Pedí un lunes y el miércoles estaba en la casa. Pagué en la puerta.', n: 'Mauricio E.', m: 'Valparaíso', e: 5 },
    { t: 'Sin letra chica', q: 'Me gustó que la página diga claro qué trae y qué no promete. Da más confianza que las que prometen todo.', n: 'Teresa M.', m: 'Quilpué', e: 5 },
    { t: 'Buena compra', q: 'Llegó bien y a tiempo. Le pongo cuatro porque me gustaría que hubiera más formatos.', n: 'Álvaro B.', m: 'Puente Alto', e: 4 },
  ],
};
OPINIONES_DEMO.general = OPINIONES_DEMO.bienestar;

/* La nota y el total NO pueden salir al azar en cada carga: si el cliente
   recarga y pasa de "128 opiniones" a "97", queda en evidencia que es de
   mentira. Se calculan del id del producto, así cada ficha tiene siempre los
   mismos números. */
function valoracion(id) {
  const semilla = (id * 2654435761) % 4294967296;   // mezcla simple y estable
  const nota = 46 + (semilla % 4);                  // de 4,6 a 4,9
  const total = 62 + (Math.floor(semilla / 7) % 179);
  /* El reparto se deduce de la nota, no se inventa aparte: si no, podría salir
     un 4,9 con la mitad de las opiniones en 3 estrellas. */
  const cinco = 62 + (nota - 46) * 8;
  const cuatro = Math.round((100 - cinco) * 0.62);
  const tres = Math.round((100 - cinco) * 0.24);
  const dos = Math.round((100 - cinco) * 0.09);
  return {
    nota: (nota / 10).toFixed(1).replace('.', ','),
    total,
    reparto: [cinco, cuatro, tres, dos, 100 - cinco - cuatro - tres - dos],
  };
}

/* Cinco estrellas, con las que faltan apagadas. La media estrella no se dibuja:
   a este tamaño no se distingue y complica el marcado para nada. */
function estrellasDe(n) {
  let s = '';
  for (let i = 1; i <= 5; i += 1) s += `<i class="${i <= n ? '' : 'off'}">${ic('star')}</i>`;
  return `<span class="pd-estrellas" aria-label="${n} de 5 estrellas">${s}</span>`;
}

function bloqueOpiniones(p) {
  const v = valoracion(p.id);
  const lista = OPINIONES_DEMO[p.cat] || OPINIONES_DEMO.general;
  const etiquetas = ['5', '4', '3', '2', '1'];

  const barras = v.reparto.map((pct, i) => `
    <div class="pd-op-barra">
      <span class="num">${etiquetas[i]}${ic('star')}</span>
      <span class="riel"><span style="width:${Math.max(pct, 0)}%"></span></span>
      <span class="pct">${Math.max(pct, 0)}%</span>
    </div>`).join('');

  const tarjetas = lista.map((o) => `
    <article class="pd-op">
      <div class="pd-op-top">
        ${estrellasDe(o.e)}
        <span class="pd-op-demo">Ejemplo</span>
      </div>
      <b class="pd-op-titulo">${o.t}</b>
      <p class="pd-op-texto">${o.q}</p>
      <div class="pd-op-pie"><b>${o.n}</b><span>${o.m}</span></div>
    </article>`).join('');

  return `
  <section class="sec-tight" id="opiniones">
    <div class="wrap">
      <div class="sec-head center"><h2>Lo que dicen de ${p.name}</h2></div>

      <div class="pd-op-resumen">
        <div class="pd-op-nota">
          <b>${v.nota}</b>
          ${estrellasDe(5)}
          <span>${v.total} opiniones</span>
        </div>
        <div class="pd-op-barras">${barras}</div>
      </div>

      <div class="pd-op-grid">${tarjetas}</div>

      <p class="pd-op-aviso">${ic('shield')}
        <span><b>Opiniones de ejemplo.</b> Todavía estamos reuniendo las primeras
        de clientes reales, y preferimos decírtelo antes que inventarlas.</span>
      </p>
    </div>
  </section>`;
}

/* ═══ POR QUÉ COMPRARLO AQUÍ ═══════════════════════════════════════════════
   [2026-10-03, 5ª vuelta] Esta tabla hace UNA sola cosa: responder por qué
   comprarlo en esta tienda y no en otra. Nada más.

   Antes llevaba encima media sección de "qué te llevas" con ingredientes y para
   quién es. Jacsson: *"toda la información es innecesaria… creo que es mejor
   agregar una tabla de por qué comprar acá nada más, y en otras secciones con
   imágenes explicar el producto a detalle"*. Y tiene razón: el detalle del
   producto necesita imágenes y espacio, no filas de tabla. Eso va en secciones
   propias; esto se queda con su único trabajo.

   ⚠️ NADA SOBRE EL ENVÍO. Esto es dropshipping: el transporte lo hace el
   proveedor. No se promete que llegue junto ni en cuántos días. Solo lo que la
   tienda sí controla: cuándo se paga, cuánto cuesta el envío y cuántos días hay
   para devolver.

   ⚠️ Las tres filas salen de la barra de confianza (`chrome()` en app.js) y de
   la página de políticas. Si una de esas promesas cambia, cambiar aquí también. */
/* [2026-10-03, 6ª vuelta] Textos exactos que dictó Jacsson. La tabla es de 3
   columnas también en el celular: *"no importa si debe deslizar hacia el lado,
   lo importante es que se vea bien"*.
   [anterior: Claude Code, 2026-10-03] mal: 'Por adelantado, con tarjeta' ·
   bien: '30 días para devolverlo' · mal: 'Los 10 días del mínimo legal' */
const COMPARA_TIENDA = [
  { q: '¿Cuándo pagas?',
    bien: 'Cuando llega a tu casa',
    mal: 'Por adelantado' },
  { q: 'El envío',
    bien: 'Gratis a todo Chile',
    mal: 'Se cobra aparte' },
  { q: 'Si no te sirve',
    bien: '30 días',
    mal: 'Los 10 del mínimo legal' },
];

function bloquePorQue() {
  const filas = COMPARA_TIENDA.map((c) => `
    <tr>
      <th scope="row">${c.q}</th>
      <td class="bien">${ic('check')}<span>${c.bien}</span></td>
      <td class="mal">${ic('x')}<span>${c.mal}</span></td>
    </tr>`).join('');

  return `
  <section class="sec-tight">
    <div class="wrap narrow">
      <div class="sec-head center"><h2>Por qué comprarlo aquí</h2></div>
      <!-- el contenedor deja deslizar hacia el lado si la pantalla es angosta -->
      <div class="pd-tabla-marco">
      <table class="pd-tabla">
        <thead>
          <tr>
            <td></td>
            <th scope="col" class="bien">Allsupletion</th>
            <th scope="col" class="mal">Otras tiendas</th>
          </tr>
        </thead>
        <tbody>${filas}</tbody>
      </table>
      </div>
    </div>
  </section>`;
}

/* ═══ LA HISTORIA DEL PRODUCTO (landing dentro de la ficha) ═══════════════════
   [2026-10-03] Jacsson: *"en otras secciones con imágenes y todo explicar el
   producto a detalle"*: qué lleva y qué hace cada ingrediente, para quién es
   (con ejemplos) y qué le resuelve. PRUEBA en un solo producto (Hallprost
   65555); si le gusta, se copia el molde a los demás.

   ⚠️ REGLAS DEL CONTENIDO, para quien agregue el siguiente producto:
     · Lo que se dice de un ingrediente sale de la ETIQUETA o de una declaración
       autorizada (EFSA, Unión Europea). Nada de "cura", "elimina", "trata".
     · "Para quién" describe la RUTINA de la persona, no síntomas. Describir un
       síntoma es prometer que lo quita.
     · Las fotos las hace Jacsson (ChatGPT). Mientras no exista el archivo, el
       hueco muestra el nombre del ingrediente en grande: nunca queda roto.
       Prompts en `01 - 🌐 Web/🎨 Prompts de imágenes para ChatGPT.md`.

   Si un producto no tiene entrada aquí, la ficha se ve como antes. */
const LANDING = {
  65555: {
    foto: '65555-origen',   // la foto natural que mandó Jacsson (2026-10-02)
    titular: 'La pepa del zapallo, sin pelar ni una',
    bajada: 'Hallprost Ultra junta dos cosas: pepa de calabaza y zinc. Nada más. '
      + 'Dos ingredientes que lees en la etiqueta y 60 cápsulas en un frasco.',
    ingredientes: [
      { nombre: 'Pepa de calabaza', etiqueta: 'Pepa de calabaza',
        img: '65555-pepa',
        que: 'Es la semilla verde del zapallo, la misma que se tuesta y se come '
          + 'de picoteo. Trae naturalmente zinc, magnesio y grasas buenas.',
        porque: 'Es uno de los ingredientes más usados en las fórmulas para '
          + 'hombres de más de 40, en Europa y en Estados Unidos. Aquí viene en '
          + 'cápsula: no hay que comprarla, tostarla ni acordarse del puñado.' },
      { nombre: 'Zinc', etiqueta: 'Óxido de zinc',
        img: '65555-zinc',
        que: 'Un mineral que el cuerpo no fabrica: tiene que llegar por lo que '
          + 'comes. Está en la carne, en los mariscos y en las mismas pepas de '
          + 'calabaza.',
        porque: 'El zinc contribuye al mantenimiento de niveles normales de '
          + 'testosterona en la sangre y al funcionamiento normal del sistema '
          + 'inmune.',
        fuente: 'Declaraciones autorizadas para el zinc en la Unión Europea (EFSA).' },
    ],
    personas: [
      { img: '65555-persona-1', titulo: 'Pasó los 40 y empezó a cuidarse',
        texto: 'Va al chequeo una vez al año, camina más y este año comió menos '
          + 'asado. Quiere sumar algo simple a la rutina, no una farmacia entera.' },
      { img: '65555-persona-2', titulo: 'No quiere tomarse seis pastillas',
        texto: 'Lee la etiqueta y entiende todo: pepa de calabaza y zinc. Sin '
          + 'mezclas de veinte cosas que no sabe pronunciar.' },
      { img: '65555-persona-3', titulo: 'Se lo compra a su papá o a su pareja',
        texto: 'Porque él solo no se lo va a comprar nunca. Con el 2x1 queda uno '
          + 'para él y otro para el hermano, el suegro o el amigo.' },
    ],
    resuelve: [
      'Comprar pepas, tostarlas y acordarte de comer un puñado todos los días.',
      'Adivinar cuánto zinc te llega con lo que comes.',
      'Pagar por adelantado y esperar que llegue: lo pagas cuando lo tienes en la mano.',
    ],
    aviso: 'Hallprost es para la rutina, no reemplaza al urólogo. Desde los 40, '
      + 'el chequeo de próstata es una vez al año: si tienes molestias, ve primero '
      + 'al médico.',
  },
};

/* Las fotos de `${AS_A}img-landing-` que YA existen. Cuando Jacsson mande una,
   se deja el .webp en esa carpeta y se agrega su nombre aquí. Si no está en la
   lista, ni se pide al servidor: se muestra el hueco con el nombre en grande
   (así no hay errores 404 en la consola). */
const FOTOS_LANDING = ['65555-origen'];

/* [2026-10-03] La imagen promocional cuadrada de los 5 productos que la tienen
   (herramientas/promo-producto.py). Va justo después del hero: es el "¿te pasa
   esto?" de ese producto, el mismo ángulo de su anuncio. Solo con 2x1 vigente,
   porque la imagen lleva pintado "2x1 · EL 2º GRATIS". */
const PROMOS = { 126340: '126340-promo-2', 83439: '83439-promo-1', 158579: '158579-promo-1', 64268: '64268-promo-1', 84659: '84659-promo-1' };
function bloquePromo(p) {
  const f = PROMOS[p.id];
  if (!f || !(typeof es2x1 === 'function' && es2x1(p))) return '';
  return `
  <section class="sec-tight pd-promo">
    <div class="wrap">
      <img src="${AS_A}img-promo-${f}.webp" alt="${p.name}: 2x1, el segundo gratis. Envío gratis y pagas al recibir." width="1080" height="1080" loading="lazy">
    </div>
  </section>`;
}

function fotoLanding(nombre, alt, texto) {
  if (!FOTOS_LANDING.includes(nombre)) {
    return `<figure class="ld-foto falta"><span class="ld-foto-falta" aria-hidden="true">${texto}</span></figure>`;
  }
  return `<figure class="ld-foto">
    <img src="${AS_A}img-landing-${nombre}.webp" alt="${alt}" loading="lazy"
         onerror="this.parentNode.classList.add('falta');this.remove()">
    <span class="ld-foto-falta" aria-hidden="true">${texto}</span>
  </figure>`;
}

function bloqueLanding(p) {
  const L = LANDING[p.id];
  if (!L) return '';

  const ingredientes = L.ingredientes.map((g, i) => `
    <article class="ld-ing${i % 2 ? ' al-reves' : ''}">
      ${fotoLanding(g.img, g.nombre, g.nombre)}
      <div class="ld-ing-texto">
        <h3>${g.nombre}</h3>
        <p class="ld-ing-etq">En la etiqueta: ${g.etiqueta}</p>
        <h4>Qué es</h4>
        <p>${g.que}</p>
        <h4>Por qué está</h4>
        <p>${g.porque}</p>
        ${g.fuente ? `<small>${g.fuente}</small>` : ''}
      </div>
    </article>`).join('');

  const personas = L.personas.map((x) => `
    <li class="ld-persona">
      ${fotoLanding(x.img, x.titulo, x.titulo)}
      <h3>${x.titulo}</h3>
      <p>${x.texto}</p>
    </li>`).join('');

  return `
  <section class="ld-origen">
    <div class="wrap">
      <div class="ld-origen-caja">
        <img class="ld-origen-foto" src="${AS_A}img-landing-${L.foto}.webp"
             alt="${p.name} junto a un zapallo abierto y sus pepas" loading="lazy"
             width="1000" height="1250">
        <div class="ld-origen-texto">
          <h2>${L.titular}</h2>
          <p>${L.bajada}</p>
        </div>
      </div>
    </div>
  </section>

  <section class="sec-tight ld-sec">
    <div class="wrap">
      <h2 class="ld-h2">Qué lleva y por qué</h2>
      <div class="ld-ings">${ingredientes}</div>
    </div>
  </section>

  <section class="sec-tight ld-sec">
    <div class="wrap">
      <h2 class="ld-h2">Para quién es</h2>
      <ul class="ld-personas">${personas}</ul>
    </div>
  </section>

  <section class="sec-tight ld-sec">
    <div class="wrap narrow">
      <h2 class="ld-h2">Lo que te ahorras</h2>
      <ul class="ld-resuelve">${L.resuelve.map((r) => `<li>${ic('check')}<span>${r}</span></li>`).join('')}</ul>
      <p class="ld-aviso">${ic('shield')}<span>${L.aviso}</span></p>
      <button class="btn btn-cta ld-cta" type="button" data-cart>${ic('cart')}<span>Agregar ${p.name} al carrito</span></button>
    </div>
  </section>`;
}

function renderProducto(el) {
  if (!el) return;
  const id = +((window.AS && AS.productoId) || new URLSearchParams(location.search).get('id'));
  const p = PRODUCTS.find((x) => x.id === id && !APARTADOS.includes(x.id));

  /* Sin id o con uno que no existe, no se deja al cliente en una página vacía:
     se le explica y se le ofrece el catálogo. */
  if (!p) {
    el.innerHTML = `<section class="sec"><div class="wrap narrow" style="text-align:center;display:grid;gap:16px;justify-items:center">
      <span class="eyebrow">No encontramos ese producto</span>
      <h1>Ese producto no está disponible</h1>
      <p class="lead">Puede que lo hayamos sacado del catálogo o que el enlace esté incompleto.</p>
      <a class="btn btn-cta" href="productos.html">Ver todos los productos ${ic('arrow')}</a>
    </div></section>`;
    document.title = 'Producto no encontrado | Allsupletion';
    return;
  }

  const f = FICHAS[p.id] || {};
  const cat = CATS.find((c) => c.id === p.cat);
  const pk = PACKS[p.id];
  const sinPremio = SIN_PREMIO.includes(p.id);

  /* El título y la descripción de la pestaña cambian con el producto: es lo que
     ve Google y lo que se ve al compartir el enlace por WhatsApp. */
  document.title = `${p.name} | Allsupletion`;
  const meta = document.querySelector('meta[name="description"]');
  if (meta) meta.setAttribute('content', `${p.name}: ${f.para || p.desc} Envío gratis y pagas en tu casa al recibir, en todo Chile.`);

  // [2026-09-27] si el producto tiene recorte limpio, ese manda sobre la foto del
  // proveedor. Aquí la imagen es lo primero que se ve, así que NO va en lazy.
  const media = fotoProducto(p.id, p.name, false) || (p.img
    ? (LIMPIAS.includes(p.id)
      ? `<picture><source srcset="${AS_A}img-${p.img}.webp" type="image/webp"><img src="${AS_A}img-${p.img}.jpg" alt="${p.name}" width="1200" height="1200"></picture>`
      : `<img src="${AS_A}img-${p.img}.jpg" alt="${p.name}" width="800" height="800">`)
    : `<div class="slot p-slot" style="--pc:${cat.c}">${ic(cat.ic)}</div>`);

  const kit = p.kit ? `<a class="p-kit" href="${KIT_LINK[p.kit][0]}">${ic('gift')}En el ${KIT_LINK[p.kit][1]}</a>` : '';

  /* Los bloques de la ficha se omiten si no están: vale más una página corta y
     cierta que una llena de corchetes vacíos. */
  const bloqueTrae = f.trae ? `
    <div class="pd-box">
      <h2>Qué trae</h2>
      <ul class="pd-lista">${f.trae.map((t) => `<li>${ic('check')}${t}</li>`).join('')}</ul>
      <small>Según la etiqueta del frasco que recibes.</small>
    </div>` : '';

  /* [2026-10-03, auditoría] 32 fichas dicen solo "Según la etiqueta del frasco":
     una caja titulada "Cómo se toma" que no dice cómo se toma. Si la dosis no se
     sabe, la caja pasa a llamarse "Antes de tomarlo" y deja lo que sí sirve: la
     advertencia de la etiqueta y para quién es. Si la ficha ya tiene historia
     (LANDING), "para quién" no se repite. Si no queda nada, no hay caja.
     [anterior: Claude Code, 2026-10-03] la caja salía siempre con "Cómo se
     toma" + f.toma + Para quién + ojo. */
  const tomaVaga = !f.toma || /^Según la etiqueta/i.test(f.toma);
  const quienToma = f.quien && !LANDING[p.id]
    ? `<p style="margin-top:8px"><b>Para quién:</b> ${f.quien}</p>` : '';
  const ojoToma = f.ojo ? `<p class="pd-ojo">${ic('shield')}${f.ojo}</p>` : '';
  const bloqueToma = !tomaVaga ? `
    <div class="pd-box">
      <h2>Cómo se toma</h2>
      <p>${f.toma}</p>
      ${quienToma}${ojoToma}
    </div>` : (quienToma || ojoToma ? `
    <div class="pd-box">
      <h2>Antes de tomarlo</h2>
      ${quienToma}${ojoToma}
    </div>` : '');

  const relacionados = PRODUCTS
    .filter((x) => x.cat === p.cat && x.id !== p.id && !APARTADOS.includes(x.id))
    .slice(0, 4);

  el.innerHTML = `
  <nav class="pd-migas" aria-label="Dónde estás">
    <div class="wrap">
      <a href="index.html">Inicio</a> ${ic('arrow')}
      <a href="productos.html?cat=${p.cat}">${cat.name}</a> ${ic('arrow')}
      <span>${p.name}</span>
    </div>
  </nav>

  <section class="sec-tight pd-hero">
    <div class="wrap">
      <!-- [2026-10-03] Jacsson: "en el hero, arriba del todo, va a estar el
           nombre con la valoración de las estrellas". Va ANTES de la foto,
           ocupando todo el ancho, en celular y en escritorio. -->
      <header class="pd-titulo">
        <span class="p-cat" style="--pc:${cat.c}">${ic(cat.ic)}${cat.name}</span>
        <h1>${p.name}</h1>
        <a class="pd-rating" href="#opiniones">
          ${estrellasDe(5)}
          <b>${valoracion(p.id).nota}</b>
          <span>${valoracion(p.id).total} opiniones</span>
        </a>
      </header>
      <div class="pd">
        <!-- [2026-10-03] La foto y, JUSTO DEBAJO, la prueba social: el mismo
             carrusel de la portada (lo arma reviews() en app.js con RESENAS). -->
        <div class="pd-izq">
          <!-- [2026-10-03] el sello 2x1 sobre la foto, como en la tarjeta. -->
          <div class="pd-media">${media}${typeof es2x1 === 'function' && es2x1(p) ? sello2x1() : ''}</div>
          <div class="pd-prueba">
            <p class="pd-prueba-tit"><b>Lo que dicen quienes ya lo usan</b>
              <span class="reviews-note">Ejemplos · todavía no hay reseñas reales</span></p>
            <div class="marquee rev" data-reviews="${p.id}"></div>
          </div>
        </div>

        <div class="pd-info">
          <!-- [anterior: Claude Code, 2026-10-03] aquí iban la categoría, el <h1>
               y la valoración (.pd-rating). Subieron a .pd-titulo, sobre la foto. -->
          <p class="lead">${f.para || p.desc}</p>
          <div class="p-tags"><span>${SEX[p.sex]}</span>${kit}</div>

          ${pk ? packOpciones(p) : ''}

          <div class="pd-precio">
            <span class="price" data-precio>${clp(p.price)}</span>
            <span class="disc-line" data-disc-price="${p.price}" data-unidades="1"
                  data-extra="${pk ? pk[0] - p.price : 0}"${sinPremio ? ' data-sin-premio' : ''}></span>
          </div>

          <!-- Urgencia: el contador apunta a la fecha real de STORE.offerEnd (se
               esconde solo cuando vence) y la llegada sale de la política de
               envíos. Nada de "quedan 3" ni "12 personas viendo esto". -->
          <div class="pd-urgencia">
            <p class="pd-cd" data-countdown>${ic('clock')}<span>${STORE.offerName}: termina en <b class="cd">--</b></span></p>
            <p class="pd-llega">${ic('truck')}<span>${textoLlegada()}</span></p>
          </div>

          <button class="btn btn-cta btn-block pd-comprar" type="button" data-cart>${ic('cart')}<span>Agregar al carrito</span></button>

          <!-- El pago al recibir, con peso propio (Jacsson, 2026-09-20). En Chile
               "contra entrega" no se entiende bien: se explica con palabras. -->
          <div class="pd-cod">
            <span class="pd-cod-ic">${ic('cash')}</span>
            <div>
              <b>Pagas en tu casa, cuando te llega</b>
              <span>No pagas nada por adelantado ni por internet. Pagas al recibir tu pedido.</span>
            </div>
          </div>

          <ul class="pd-sellos">
            <li>${ic('truck')}Envío gratis a todo Chile</li>
            <li>${ic('shield')}30 días para devolverlo</li>
            <li>${ic('clock')}Despacho en 24 a 48 horas</li>
          </ul>
        </div>
      </div>
    </div>
  </section>

  <!-- [anterior: Claude Code, 2026-10-03 12:20] el carrusel iba aquí, después
       de todo el hero. Jacsson: "no, es justo por debajo de la imagen". Ahora
       vive en .pd-izq, pegado bajo la foto. -->

  ${bloquePromo(p)}

  ${bloqueLanding(p)}

  <!-- [2026-10-03] Con landing, "Qué trae" sobra: los ingredientes ya se
       explicaron arriba con foto. "Cómo se toma" se queda. -->
  ${(LANDING[p.id] ? bloqueToma : bloqueTrae || bloqueToma) ? `
  <section class="sec-tight">
    <div class="wrap">
      <div class="pd-boxes">${LANDING[p.id] ? '' : bloqueTrae}${bloqueToma}</div>
    </div>
  </section>` : ''}

  ${bloquePorQue()}

  <section class="sec-tight">
    <div class="wrap narrow">
      <div class="sec-head center"><h2>Lo que más nos preguntan</h2></div>
      <div class="faq">
        ${FAQ_PRODUCTO.map(([q, a]) => `<details><summary>${q}<span data-ic="plus"></span></summary><p class="faq-a">${a}</p></details>`).join('')}
      </div>
      <p class="pd-legal">Este producto es un suplemento alimenticio. No reemplaza una alimentación equilibrada ni un tratamiento médico. Si estás embarazada, amamantando o tomas medicamentos, consulta a tu médico antes de empezar.</p>
    </div>
  </section>

  ${bloqueOpiniones(p)}

  ${relacionados.length ? `
  <section class="sec alt">
    <div class="wrap">
      <div class="sec-head"><span class="eyebrow">De la misma categoría</span><h2>También te puede servir</h2></div>
      <div class="p-grid">${relacionados.map(productCard).join('')}</div>
    </div>
  </section>` : ''}

  <section class="sec-tight">
    <div class="wrap" style="text-align:center">
      <a class="pd-volver" href="productos.html" style="font-weight:700">Ver todos los productos ${ic('arrow')}</a>
    </div>
  </section>

  <div class="buybar pd-buybar" aria-hidden="true">
    <div class="wrap">
      <div class="buybar-info"><b>${p.name}</b><span><span data-bar-uds></span><span data-bar-precio>${clp(p.price)}</span> · pagas al recibir</span></div>
      <button class="btn btn-cta" type="button" data-cart>${ic('cart')}<span>Agregar</span></button>
    </div>
  </div>`;
  barraCompra(el);
  unidadesDelEnlace(el);

  if (document.body.classList.contains('has-disc') && window.aplicaDescuento) window.aplicaDescuento(el);
}
